import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100vh;
  min-width: 420px;
  padding-bottom: 20px;
  background: linear-gradient(-90deg, #7159c1, #ab59c1);
`;
